export default "__VITE_ASSET__BMmxKGTQ__"